import React, { useRef, useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Seo from "./components/Seo";
import Header from "./components/Header";
import Hero from "./components/Hero";
import Stats from "./components/Stats";
import Services from "./components/Services";
import Sectors from "./components/Sectors";
import ZoneIntervention from "./components/ZoneIntervention";
import References from "./components/References";
import WhyUs from "./components/WhyUs";
import Process from "./components/Process";
import Testimonials from "./components/Testimonials";
import FAQ from "./components/FAQ";
import QuoteForm from "./components/QuoteForm";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import Recrutement from "./pages/Recrutement";
import Ticket from "./pages/Ticket";
import Qualite from "./pages/Qualite";
import EspacesVerts from "./pages/EspacesVerts";
import ServicePage from "./pages/ServicePage";
import Intendance from "./pages/Intendance";
import Realisations from "./pages/Realisations";
import Ville from "./pages/Ville";
import Villes from "./pages/Villes";
import MentionsLegales from "./pages/MentionsLegales";
import QualitySection from "./components/QualitySection";
import AIAssistant from "./components/AIAssistant";
import CookieBanner from "./components/CookieBanner";
import QuickAccess from "./components/QuickAccess";
import { Toaster } from "./components/ui/toaster";
import Admin from "./pages/Admin";
import CollaboratorApp from "./pages/CollaboratorApp";
import Suivi from "./pages/Suivi";
import GpsTracking from "./components/GpsTracking";
import { trackVisit } from "./api";

const getTrackSession = () => {
  let s = localStorage.getItem("visit_session");
  if (!s) {
    s = "v-" + Math.random().toString(36).slice(2, 12);
    localStorage.setItem("visit_session", s);
  }
  return s;
};

const Landing = () => {
  const quoteRef = useRef(null);
  const contactRef = useRef(null);

  useEffect(() => {
     
    trackVisit({
      path: window.location.pathname,
      referrer: document.referrer || "direct",
      session_id: getTrackSession(),
    }).catch(() => {});
  }, []);

  const scrollToQuote = () =>
    quoteRef.current?.scrollIntoView({ behavior: "smooth" });
  const scrollToContact = () =>
    contactRef.current?.scrollIntoView({ behavior: "smooth" });

  return (
    <div className="min-h-screen bg-white text-neutral-900 font-body">
      <Header onQuote={scrollToQuote} />
      <QuickAccess />
      <main>
        <Hero onQuote={scrollToQuote} onContact={scrollToContact} />
        <Stats />
        <Services onQuote={scrollToQuote} />
        <Sectors />
        <ZoneIntervention />
        <References />
        <WhyUs />
        <Process />
        <GpsTracking />
        <QualitySection />
        <Testimonials />
        <FAQ />
        <QuoteForm ref={quoteRef} />
        <Contact ref={contactRef} />
      </main>
      <Footer />
      <AIAssistant />
      <CookieBanner />
      <Toaster />
    </div>
  );
};

function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<><Seo path="/" title="PTITSERVICES-PRO — Nettoyage de bureaux & entretien B2B dans tout le Grand Nord de la France" description="Entreprise de nettoyage professionnel B2B dans tout le Grand Nord de la France (siège Servins, 62) : entretien de bureaux, bases vie de chantiers et fourniture de consommables. Devis gratuit sous 24h, équipe réactive, assurée et un interlocuteur unique." /><Landing /></>} />
          <Route path="/recrutement" element={<><Seo path="/recrutement" title="Recrutement — Rejoignez PTITSERVICES-PRO (agents de propreté Hauts-de-France)" description="Offres d'emploi PTITSERVICES-PRO : agents de propreté, entretien de bureaux et bases vie de chantiers dans les Hauts-de-France. Postulez en ligne." /><Recrutement /></>} />
          <Route path="/recrutement/:id" element={<><Seo path="/recrutement" title="Offre d'emploi — PTITSERVICES-PRO" /><Recrutement /></>} />
          <Route path="/ticket" element={<><Seo path="/ticket" title="Service client — Déposer un ticket | PTITSERVICES-PRO" description="Déposez une demande ou un signalement (réclamation qualité, passage supplémentaire, accès, facturation) et suivez son traitement en ligne." /><Ticket /></>} />
          <Route path="/qualite" element={<><Seo path="/qualite" title="Suivi & contrôles qualité réguliers — PTITSERVICES-PRO" description="Notre démarche qualité : contrôles réguliers sur site par nos responsables de secteur, grille en 6 zones, rapports PDF et actions correctives suivies." /><Qualite /></>} />
          <Route path="/espaces-verts" element={<><Seo path="/espaces-verts" title="Entretien des espaces verts B2B — 40 km autour de Servins (Arras, Lens, Béthune) | PTITSERVICES-PRO" description="Tonte, taille de haies, désherbage, débroussaillage, ramassage de feuilles et évacuation des déchets verts pour entreprises, copropriétés et collectivités dans un rayon de 40 km autour de Servins (62). Devis gratuit sous 24h." /><EspacesVerts /></>} />
          <Route path="/intendance" element={<Intendance />} />
          <Route path="/services/:slug" element={<ServicePage />} />
          <Route path="/villes" element={<><Seo path="/villes" title="Villes desservies — nettoyage B2B dans le Grand Nord (Lille, Paris, Rouen, Reims, Rennes…) | PTITSERVICES-PRO" description="Société de nettoyage professionnel intervenant dans toutes les métropoles du Grand Nord de la France : Lille, Arras, Amiens, Paris, Rouen, Reims, Rennes, Metz, Strasbourg… Devis gratuit sous 24 h." /><Villes /></>} />
          <Route path="/nettoyage/:slug" element={<Ville />} />
          <Route path="/realisations" element={<><Seo path="/realisations" title="Réalisations avant / après — nettoyage, espaces verts, petits travaux | PTITSERVICES-PRO" description="Photos avant/après de nos chantiers de nettoyage de bureaux, bases vie, espaces verts et homme toutes mains dans le Grand Nord de la France." /><Realisations /></>} />
          <Route path="/mentions-legales" element={<><Seo path="/mentions-legales" title="Mentions légales & confidentialité — PTITSERVICES-PRO" noindex /><MentionsLegales /></>} />
          <Route path="/ticket/:ref" element={<><Seo path="/ticket" title="Suivi de ticket — PTITSERVICES-PRO" noindex /><Ticket /></>} />
          <Route path="/admin" element={<><Seo path="/admin" title="Espace CRM — PTITSERVICES-PRO" noindex /><Admin /></>} />
          <Route path="/app" element={<><Seo path="/app" title="Espace intervenant — PTITSERVICES-PRO" noindex /><CollaboratorApp /></>} />
          <Route path="/suivi/:token" element={<><Seo path="/suivi" title="Suivi de prestation — PTITSERVICES-PRO" noindex /><Suivi /></>} />
        </Routes>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
